import Vue from 'vue';
import 'vuetify/dist/vuetify.min.css';
import debounce from 'debounce';
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.prototype.$debounce = debounce(function(this: any, methodName: string, ...parameters: any[]) {
  (this as any)[methodName].call(this as any, ...parameters);
}, 300);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDClzKp3N2FJLZXXC6w6eJm2Jc7hP44H1o',
  },
})